import { render } from "./PreviewModal.vue?vue&type=template&id=06a12677&scoped=true"
import script from "./PreviewModal.vue?vue&type=script&lang=js"
export * from "./PreviewModal.vue?vue&type=script&lang=js"

import "@/Common/Styles/previewModal.scss?vue&type=style&index=0&id=06a12677&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06a12677"]])

export default __exports__